import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, inject, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import {
  BaseText,
  Heading,
  ContentDisplay,
  ChipContext,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioDistributionResponse } from '@/modules/wallet-builder/src/services/types/models/IBffInvestments';
import { IPortfolioAbout } from '@/modules/wealth/services/portfolio';


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutStrategy',
  setup(__props) {

const router = useRouter();

const injectedPortfolioDistribution = inject<IPortfolioDistributionResponse>(
  'portfolioDistribution'
);
const portfolioDistribution = ref<IPortfolioDistributionResponse | undefined>(
  injectedPortfolioDistribution
);

const portfolioTitle = computed(() => {
  if (isEnabledBffPortfolioMigration.value) {
    return portfolioAbout.value?.suggestionName ?? portfolioAbout.value?.name;
  }

  return (
    portfolioDistribution.value?.portfolio.suggestionName ??
    portfolioDistribution.value?.portfolio.name
  );
});

const injectedPortfolioAbout = inject<IPortfolioAbout>('portfolioAbout');
const portfolioAbout = ref<IPortfolioAbout | undefined>(injectedPortfolioAbout);

const riskCategoryColors: { [key: string]: NebraskaColors } = {
  'Muito baixo': NebraskaColors.riskLow,
  Baixo: NebraskaColors.riskLow,
  Médio: NebraskaColors.riskMedium,
  Alto: NebraskaColors.riskHigh,
  'Muito alto': NebraskaColors.riskHigh
};

function goToCosts() {
  router.push({ name: 'costs' });
}

const isPortfolioDistributionLoading = inject(
  'isPortfolioDistributionLoading'
) as Ref<boolean>;

const isPortfolioAboutLoading = inject(
  'isPortfolioAboutLoading'
) as Ref<boolean>;

const isEnabledBffPortfolioMigration = inject(
  'isEnabledBffPortfolioMigration'
) as Ref<boolean>;

const shouldShowFeesMessage = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.shouldShowFeesMessage
    : portfolioDistribution?.value?.portfolio?.shouldShowFeesMessage;
});

const riskTitle = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.risk?.title
    : portfolioDistribution?.value?.portfolio?.riskTitle;
});

const riskDescription = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.risk?.description
    : portfolioDistribution?.value?.portfolio?.riskDescription;
});

const portfolioStategyDescription = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.strategyDescription
    : portfolioDistribution?.value?.portfolio?.strategyDescription;
});

const isCustomPortfolio = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.isCustom
    : portfolioDistribution?.value?.portfolio?.isCustom;
});

const riskCategory = computed(() => {
  return isEnabledBffPortfolioMigration.value
    ? portfolioAbout?.value?.risk?.category
    : portfolioDistribution?.value?.portfolio?.riskCategory;
});

return { __sfc: true,router, injectedPortfolioDistribution, portfolioDistribution, portfolioTitle, injectedPortfolioAbout, portfolioAbout, riskCategoryColors, goToCosts, isPortfolioDistributionLoading, isPortfolioAboutLoading, isEnabledBffPortfolioMigration, shouldShowFeesMessage, riskTitle, riskDescription, portfolioStategyDescription, isCustomPortfolio, riskCategory, BaseText, Heading, ContentDisplay, ChipContext, SkeletonLoader, NebraskaColors }
}

})